module.exports = __webpack_public_path__ + "img/icon-invoices.98668877.svg";